import { JobPhase } from '@prisma/client';
import Link from 'next/link';
import clsx from 'clsx';
import { useState } from 'react';
import { LeadFormModal } from '~/components/pages/leads/LeadFormModal';
import { FAIcon } from '~/components/utils/FAIcons';
import Popover from '~/components/utils/Popover';
import { useUserContext } from '~/react_context/UserContext';
import { useNavStore } from '~/stores/nav.store';

const menuItemClassName = 'text-gray-700 hover:bg-gray-200 group flex items-center px-3 py-2';

export const SidebarCreateJobButton = () => {
	const { collapsedNav: isCollapsed } = useNavStore();
	const { isLeadsEnabled } = useUserContext();
	const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);

	return (
		<>
			{isLeadModalOpen && <LeadFormModal onClose={() => setIsLeadModalOpen(false)} />}
			<Popover>
				<Popover.Button
					closedClassName={clsx('bg-primary text-white flex justify-center w-full grow transition-all duration-300 ease-in-out', {
						'w-10 h-10': isCollapsed,
						'w-full h-10': !isCollapsed,
					})}
					openClassName={clsx('bg-primary-dark text-white flex justify-center transition-all duration-300 ease-in-out', {
						'w-10 h-10': isCollapsed,
						'w-full h-10': !isCollapsed,
					})}
					id="create-new-job-sidebar-button"
				>
					<FAIcon icon="plus" />
					<span
						className={clsx('whitespace-nowrap pl-2 transition-opacity duration-300 ease-in-out text-center', {
							hidden: isCollapsed,
							block: !isCollapsed,
						})}
					>
						Create New
					</span>
				</Popover.Button>
				<Popover.Panel xPosition={clsx('left-0 right-0 transition-all duration-300 ease-in-out', { 'w-40': isCollapsed })} zIndex="z-20">
					<div>
						<Link href={`/jobs/create/?type=${JobPhase.ESTIMATE}`} className={menuItemClassName} id="create-new-bid-sidebar-button">
							<FAIcon icon="bullseye-arrow" className="mr-2 text-primary" />
							Bid
						</Link>
						<Link href={`/quick-estimate/create`} className={menuItemClassName} id="create-new-quick-estimate-sidebar-button">
							<FAIcon icon="bolt" className="mr-2 text-primary" />
							Quick Estimate
						</Link>
						<Link href="/quick-checkout" className={menuItemClassName} id="create-new-quick-checkout-sidebar-button">
							<FAIcon icon="credit-card" className="mr-2 text-primary" />
							Quick Checkout
						</Link>
						<Link href={`/jobs/create/?type=${JobPhase.WORK_ORDER}`} className={menuItemClassName} id="create-new-won-job-sidebar-button">
							<FAIcon icon="hammer" className="mr-2 text-primary" />
							Won Job
						</Link>
						{isLeadsEnabled && (
							<button
								className={clsx(menuItemClassName, 'w-full')}
								id="create-new-lead-sidebar-button"
								onClick={() => setIsLeadModalOpen(true)}
								type="button"
							>
								<FAIcon icon="clipboard-list" className="mr-2 text-primary" />
								Lead
							</button>
						)}
					</div>
				</Popover.Panel>
			</Popover>
		</>
	);
};
